(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/slide-in-container/assets/javascripts/views/slide-in-container.js') >= 0) return;  svs.modules.push('/components/app/slide-in-container/assets/javascripts/views/slide-in-container.js'); 

(function(Backbone, svs) {
  'use strict';

  svs.app.slide_in_container.views.SlideInContainer = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.app.slide_in_container.templates.slide_in_container(data);
    },
    el: '#slide-in-container',
    ui: {
      header: '#slide-in-container-header',
      container: '.slide-in-container',
      dimmer: '.js-navigation-dimmer',
      content: '.slide-in-container-content',
      notification: '.tab-toggle-notification'
    },
    childViewEvents: {
      'toggle:close': 'toggleOpenClose'
    },
    events: {
      'click @ui.dimmer': 'closeMenu',
      'click .js-tab-toggle': 'toggleOpenClose'
    },
    regions: {
      header: '#slide-in-container-header',
      content: '.slide-in-container-content'
    },

    closeMenu: function() {
      this.toggleOpenClose(false);
    },
    attachElContent: function(html) {
      this.$el.prepend(html);
      return this;
    },

    onWindowResize: function() {
      var windowHeight = $(window).height();
      var topContentHeight = $('#top-content').outerHeight();
      var contentHeight = windowHeight - topContentHeight;

      this.ui.content.css('height', contentHeight);
    },

    initialize: function() {
      var self = this;
      if (svs.core.detect.formfactor.desktop()) {
        this.onWindowResizeCallback = this.onWindowResize.bind(this);

        $(window).on('resize', this.onWindowResizeCallback);
      }

      this.toggleOpenClose = this.toggleOpenClose.bind(this);
      this.dimmer = new svs.components.Dimmer(function() {
        document.activeElement.blur();
        self.toggleOpenClose(false);
      });
    },

    onDestroy: function() {
      $(window).off('resize', this.onWindowResizeCallback);
      this.contentView.destroy();
      this.dimmer.destroy();
    },

    onRender: function() {
      if (!this.model.get('disableHeader')) {
        this.showChildView(
          'header',
          new svs.app.slide_in_container.views.SlideInContainerHeader({
            model: new Backbone.Model(this.model.get('headerOptions'))
          })
        );
      }
      try {
        this.contentView = this.model.get('view').el ?
            this.model.get('view') :
            new this.model.get('view')(this.model.get('viewOptions'));
        this.showChildView('content', this.contentView);
        if (this.model.get('useContentScroll')) {
          this.ui.content.css('overflow-y', 'auto');
        }
      } catch (e) {
        svs.app.slide_in_container.logger.error(
          'Error creating instance of or showing supplied view. ',
          e
        );
      }

      if (this.model.get('swipeContent')) {
        var options = {
          scrollbars: false,
          alwaysScroll: false
        };
        svs.components.swiper.init(this.ui.container[0], options);
      }

      if (this.model.get('useDimmer')) {
        this.dimmer.render();
      }

      svs.core.detect.formfactor.desktop() && this.onWindowResize();
    },

    toggleOpenClose: function(toggleToOpen) {
      var isContainerOpened = !this.ui.container.hasClass('opened');
      toggleToOpen =
          arguments.length > 1 && _.isObject(toggleToOpen) ?
            false :
            toggleToOpen;
      if (this._firstRender) {
        var self = this;
        this.listenToOnce(this.content, 'show', function() {
          setTimeout(function() {
            self.toggleOpenClose(toggleToOpen);
          }, 50);
        });
        this.render();
      } else {
        if (this.model.get('useDimmer')) {
          if (isContainerOpened === false) {
            this.dimmer.hide();
          } else {
            this.dimmer.show();
          }
        }
        this.model.get('useBodyScrollLock') &&
            this.toggleBodyScrollLock(isContainerOpened);
        if (this.ui.container.hasClass('opened')) {
          svs.app.slideInContainer.channel().trigger('close');
        } else {
          svs.app.slideInContainer.channel().trigger('open');
        }
        this.ui.container.toggleClass('opened', toggleToOpen);
        svs.core.detect.formfactor.desktop() && this.onWindowResize();
      }
    },

    toggleBodyScrollLock: function(toggleToOpen) {
      if (toggleToOpen) {
        svs.components.swiper.disableBodyScroll();
      } else {
        svs.components.swiper.enableBodyScroll();
      }
    },

    onDomRefresh: function() {
      var hammerElement = new window.Hammer(this.el);

      hammerElement
        .get('pan')
        .set({ direction: window.Hammer.DIRECTION_HORIZONTAL });
      hammerElement.on('swiperight', function() {
        svs.app.slideInContainer.slider.toggleOpenClose(false);
      });
    },

    toggleNotification: function(toggle) {
      this.ui.notification.toggleClass('hide', toggle);
    }
  });
})(Backbone, svs);

 })(window);